import React, { useState } from "react";
import { compose, withFieldValidation } from "@transformd-ltd/sdk";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Modal, Button } from "react-bootstrap";

const FIELD_ID = "6293af4f0fdd5f011b6c13a2";
const FIELD_TAG = "whatBestDescribesYou";
const IMAGE_HEIGHT = "100px";

const CHOICES = [
  {
    type: "minimal-card",
    label: "I currently work in policing, law enforcement, or justice",
    image_source:
      "https://www.policebank.com.au/media/transformd/occupation-images/1.png",
    image_height: IMAGE_HEIGHT,
  },
  {
    type: "minimal-card",
    label:
      "I am employed by a government agency or regulator (e.g. APRA, ASIC)",
    image_source:
      "https://www.policebank.com.au/media/transformd/occupation-images/4.png",
    image_height: IMAGE_HEIGHT,
  },
  {
    type: "minimal-card",
    label: "I am a student at the Police Academy",
    image_source:
      "https://www.policebank.com.au/media/transformd/occupation-images/3.png",
    image_height: IMAGE_HEIGHT,
  },
  {
    type: "minimal-card",
    label: "I am a police or law enforcement contractor or trainer",
    image_source:
      "https://www.policebank.com.au/media/transformd/occupation-images/4.png",
    image_height: IMAGE_HEIGHT,
  },
  {
    type: "minimal-card",
    label: "I am a security industry worker",
    image_source:
      "https://www.policebank.com.au/media/transformd/occupation-images/4.png",
    image_height: IMAGE_HEIGHT,
  },
  {
    type: "minimal-card",
    label:
      "I am a direct family member of a police officer or law enforcement worker",
    image_source:
      "https://www.policebank.com.au/media/transformd/occupation-images/5.png",
    image_height: IMAGE_HEIGHT,
  },
  {
    type: "minimal-card",
    label: "I am related to a Police Bank member",
    image_source:
      "https://www.policebank.com.au/media/transformd/occupation-images/5.png",
    image_height: IMAGE_HEIGHT,
  },
  {
    type: "minimal-card",
    label:
      "I am an essential worker (e.g. police, nurse, teacher) or Board approved individual outside the other standard categories",
    image_source:
      "https://www.policebank.com.au/media/transformd/occupation-images/4.png",
    image_height: IMAGE_HEIGHT,
  },
  {
    type: "minimal-card",
    label: "None of the above / I'm applying as an individual",
    image_source:
      "https://www.policebank.com.au/media/transformd/occupation-images/6.png",
    image_height: IMAGE_HEIGHT,
  },
];

let ROW_CHOICES = [];
let currentRow = [];
CHOICES.forEach((choice, idx) => {
  currentRow.push(choice);

  if (idx % 2 !== 0 || idx == CHOICES.length - 1) {
    ROW_CHOICES.push(currentRow);
    currentRow = [];
  }
});

console.log("DEBUG", ROW_CHOICES);

const AboutYouCards = ({ getData }) => {
  const [show, setShow] = useState(false);
  const onChange = (e) => {
    getData().setFieldValue(FIELD_ID, e.target.value);
  };

  const selectedValue = getData().getFieldValue(FIELD_ID);
  return (
    <div style={{ width: "100%" }} data-tag="whatBestDescribesYou">
      {/* --- DISABLED help info modal 02/04/24 BATIT-645 */}
      {/* <HelpModalReferredByCoreMember show={show} onClose={() => setShow(false)} /> */}
      <div className="custom__rdlist__aboutyou__label">
        <span>What best describes you?</span>
        {/* <span style={{ marginLeft: 8, cursor: "pointer" }}>
          <FontAwesomeIcon icon={faCircleInfo} onClick={() => setShow(true)} />
        </span> */}
      </div>
      <div className="custom__rdlist__aboutyou">
        {ROW_CHOICES.map(([choice1, choice2]) => (
          <div
            key={`choice-about-you-cards-row-${choice1?.label || ""}-${
              choice2?.label || ""
            }`}
            className="custom__rdlist__aboutyou__row_outer"
          >
            <div className="custom__rdlist__aboutyou__row_inner">
              {choice1 && choice1?.type === "card" && (
                <Card
                  key={`choice-about-you-cards-${choice1.label}`}
                  label={choice1.label}
                  onChange={onChange}
                  selectedValue={selectedValue}
                  imgSrc={choice1.image_source}
                  imgHeight={choice1.image_height}
                />
              )}

              {choice2 && choice2?.type === "card" && (
                <Card
                  key={`choice-about-you-cards-${choice2.label}`}
                  label={choice2.label}
                  onChange={onChange}
                  selectedValue={selectedValue}
                  imgSrc={choice2.image_source}
                  imgHeight={choice2.image_height}
                />
              )}

              {choice1 && choice1?.type === "minimal-card" && (
                <MinimalCard
                  key={`choice-about-you-cards-${choice1.label}`}
                  label={choice1.label}
                  onChange={onChange}
                  selectedValue={selectedValue}
                />
              )}

              {choice2 && choice2?.type === "minimal-card" && (
                <MinimalCard
                  key={`choice-about-you-cards-${choice2.label}`}
                  label={choice2.label}
                  onChange={onChange}
                  selectedValue={selectedValue}
                />
              )}
            </div>
          </div>
        ))}
        {/* <Card
          label="Employee of a Police Force"
          onChange={onChange}
          selectedValue={selectedValue}
          imgSrc="https://www.policebank.com.au/media/transformd/occupation-images/1.png"
          imgHeight={IMAGE_HEIGHT}
        />
        <Card
          label="I'm a police academy student"
          onChange={onChange}
          selectedValue={selectedValue}
          imgSrc="https://www.policebank.com.au/media/transformd/occupation-images/3.png"
          imgHeight={IMAGE_HEIGHT}
        />
        <Card
          label="I'm studying"
          onChange={onChange}
          selectedValue={selectedValue}
          imgSrc="https://www.policebank.com.au/media/transformd/occupation-images/2.png"
          imgHeight={IMAGE_HEIGHT}
        />
        <Card
          label="I'm working"
          onChange={onChange}
          selectedValue={selectedValue}
          imgSrc="https://www.policebank.com.au/media/transformd/occupation-images/4.png"
          imgHeight={IMAGE_HEIGHT}
        />
        <Card
          label="Other"
          onChange={onChange}
          selectedValue={selectedValue}
          imgSrc="https://www.policebank.com.au/media/transformd/occupation-images/6.png"
          imgHeight={IMAGE_HEIGHT}
        />
        <Card
          label="Referred by a Police Bank member"
          onChange={onChange}
          selectedValue={selectedValue}
          imgSrc="https://www.policebank.com.au/media/transformd/occupation-images/5.png"
          imgHeight={IMAGE_HEIGHT}
        /> */}
        {/* <MinimalCard
          label="Other"
          onChange={onChange}
          selectedValue={selectedValue}
        />
        <MinimalCard
          label="Referred by a policebank member"
          onChange={onChange}
          selectedValue={selectedValue}
        /> */}
      </div>
    </div>
  );
};

const TopSection = ({ imgSrc, imgWidth, imgHeight }) => (
  <div className="custom__section__aboutyou--top">
    <img src={imgSrc} style={{ height: imgHeight }} />
    {/* <div className="overlay__circle__aboutyou" /> */}
  </div>
);

const BottomSection = ({ label, onChange, selectedValue }) => {
  const checked = selectedValue === label;
  return (
    <div className="custom__section__aboutyou--bottom">
      <div className="custom__radio__container">
        <input
          type="radio"
          value={label}
          name="aboutyou"
          checked={checked}
          onChange={onChange}
        />
        <div className="custom__radio__label">{label}</div>
      </div>
    </div>
  );
};

const Card = ({
  label,
  onChange,
  selectedValue,
  imgSrc,
  imgWidth,
  imgHeight,
}) => {
  return (
    <div className="custom__card__aboutyou custom__card__aboutyou--lg">
      <TopSection imgSrc={imgSrc} imgWidth={imgWidth} imgHeight={imgHeight} />
      <BottomSection
        label={label}
        onChange={onChange}
        selectedValue={selectedValue}
      />
    </div>
  );
};

const MinimalCard = ({ label, onChange, selectedValue }) => {
  const checked = selectedValue === label;

  return (
    <div className="custom__card__aboutyou custom__card__aboutyou--sm">
      <div className="custom__radio__container">
        <input
          type="radio"
          value={label}
          name="aboutyou"
          checked={checked}
          onChange={onChange}
        />
        <div className="custom__radio__label">{label}</div>
      </div>
    </div>
  );
};

function HelpModalReferredByCoreMember({ show = false, onClose }) {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>What is a core member?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Referred by a family member who qualifies under the following
          criteria:
        </p>
        <ul>
          <li>Existing Police Bank Member</li>
          <li>NSW Police Force</li>
          <li>Australian Federal Police (AFP)</li>
          <li>Tasmania Police</li>
          <li>South Australia Police</li>
          <li>Victoria Police</li>
          <li>Western Australia Police Force</li>
          <li>Queensland Police Service</li>
          <li>Northern Territory Police</li>
          <li>Australia Border Force (ABF)</li>
          <li>Police Legacy</li>
          <li>Australian Financial Services Regulator (APRA, ASIC etc.)</li>
          <li>Teachers</li>
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default compose(withFieldValidation)(AboutYouCards);
